import { Form, Col } from "react-bootstrap";

export default function SpinsPicker({ formData, setFormData, name, inputOnly = false }) {
    const spinsOptions = Array.from({ length: 50 }, (_, i) => i + 1);

    // Set the default value to 3 if spins_threshold or min_spins is not already set in formData
    if (!formData.spins_threshold && !formData.min_spins) {
        setFormData({
            ...formData,
            spins_threshold: 3,
            min_spins: 3,
            spins: 3,
        });
    }

    const input = (
        <Form.Group as={Col} className="col-12 col-xl">
            <Col>
                <Form.Select
                    id={`${name}-spins-selector`}
                    className="form-select d-inline-block px-2"
                    value={formData.spins_threshold || formData.min_spins || formData.spins}
                    onChange={e =>
                        setFormData({
                            ...formData,
                            spins_threshold: e.target.value,
                            min_spins: e.target.value,
                            spins: e.target.value,
                        })
                    }>
                    {spinsOptions.map(spin => (
                        <option key={spin} value={spin}>
                            {spin} {spin === 1 ? "spin" : "spins"}
                        </option>
                    ))}
                </Form.Select>
            </Col>
        </Form.Group>
    );

    if (inputOnly) {
        return input;
    }
    return (
        <div className={`${name === "musicReportsedit" ? "col-xl-4" : "col-xl-2"} ${name === "musicAlertsedit" && "col-12 col-xl-6"}`}>
            <Form.Label className="form-label text-nowrap">Minimum Spins</Form.Label>
            {input}
        </div>
    );
}
